import { ReactNode } from 'react';
import { generateTrackingId } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { useIsCompactMode } from '@frontend/responsiveness';
import { SurfaceHeader } from '@frontend/surface-header';
import { ScreenLayoutHeader } from './screen-layout';

type Props = {
  onClose?: () => void;
  children?: ReactNode;
  customHeader?: ScreenLayoutHeader;
};

export const CallInsightHeader = ({ customHeader, onClose: handleClose }: Props) => {
  const { t } = useTranslation('call-insight-panel');
  const isCompactMode = useIsCompactMode();

  return (
    <SurfaceHeader.Root>
      <SurfaceHeader.Row>
        {(isCompactMode || customHeader?.headerStart) && (
          <SurfaceHeader.Start>
            {customHeader?.headerStart || <SurfaceHeader.Icon iconName='caret-left-small' onClick={handleClose} />}
          </SurfaceHeader.Start>
        )}
        <SurfaceHeader.Title>{customHeader?.headerTitle || t('Call Insights')}</SurfaceHeader.Title>
        {(!isCompactMode || customHeader?.headerActions) && (
          <SurfaceHeader.Actions>
            {customHeader?.headerActions || (
              <SurfaceHeader.Icon
                iconName='x'
                className='close-btn'
                label={t('Close panel')}
                data-testid='close-button'
                trackingId={generateTrackingId({
                  prefix: 'call-insight-panel',
                  component: 'close-btn',
                })}
                onClick={handleClose}
              />
            )}
          </SurfaceHeader.Actions>
        )}
      </SurfaceHeader.Row>
      {customHeader?.headerBody && <SurfaceHeader.Body>{customHeader?.headerBody}</SurfaceHeader.Body>}
    </SurfaceHeader.Root>
  );
};
